export const LOAD_ITEMS_FAIL = 'la/domain/items/LOAD_FAIL';
export const LOAD_ITEMS_REQUEST = 'la/domain/items/LOAD_REQUEST';
export const LOAD_ITEMS_SUCCESS = 'la/domain/items/LOAD_SUCCESS';
